import * as ProgressPrimitive from "@radix-ui/react-progress"
import clsx from "clsx"

import styles from "./MediaProgress.module.css"

const progress = {
  idle: 0,
  uploading: 90,
  success: 100,
  error: 100
} as const

export type Status = "idle" | "uploading" | "success" | "error"

interface MediaProgressProps {
  status: Status
}

export function MediaProgress(props: MediaProgressProps) {
  const { status } = props

  return (
    <div className={styles.root}>
      <ProgressPrimitive.Root
        className={styles.progress}
        value={progress[status]}
      >
        <ProgressPrimitive.Indicator
          className={clsx(styles.indicator, styles[`indicator-${status}`])}
          style={{ transform: `translateX(-${100 - progress[status]}%)` }}
        />
      </ProgressPrimitive.Root>
    </div>
  )
}
